import CryptoJS from "crypto-js";
import forge from "node-forge";

export function encryptHybrid(data, rsaPublicKeyPEM, message) {
  // Generate a random AES key
  const aesKey = CryptoJS.lib.WordArray.random(32);
  const iv = CryptoJS.lib.WordArray.random(16);

  // Encrypt the data using AES
  const encrypted = CryptoJS.AES.encrypt(data, aesKey, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  // Encrypt the AES key using RSA-OAEP with node-forge
  const publicKey = forge.pki.publicKeyFromPem(rsaPublicKeyPEM);
  const aesKeyBytes = CryptoJS.enc.Base64.stringify(aesKey);
  const encryptedAesKeyBytes = publicKey.encrypt(
    forge.util.decode64(aesKeyBytes),
    "RSA-OAEP"
  );
  const encryptedAesKey = forge.util.encode64(encryptedAesKeyBytes);

  // Return everything as Base64 strings
  return {
    encryptedData: encrypted.ciphertext.toString(CryptoJS.enc.Base64),
    iv: iv.toString(CryptoJS.enc.Base64),
    encryptedKey: encryptedAesKey,
    message: message,
  };
}